var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_61_21",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 38,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 1H1V31H39V1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_61_21)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_61_21",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 38,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 1H1V31H39V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_61_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3334 4.99991C38.3334 2.98325 36.6834 1.33325 34.6667 1.33325H5.33341C3.31675 1.33325 1.66675 2.98325 1.66675 4.99991V26.9999C1.66675 29.0166 3.31675 30.6666 5.33341 30.6666H34.6667C36.6834 30.6666 38.3334 29.0166 38.3334 26.9999V4.99991ZM34.6667 4.99991L20.0001 14.1666L5.33341 4.99991H34.6667ZM34.6667 26.9999H5.33341V8.66658L20.0001 17.8332L34.6667 8.66658V26.9999Z",
    fill: "#FF573B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e1e60c2f5aff1722efb7e94011615900.svg";
export { ForwardRef as ReactComponent };